import { SiteActivityEvent, generator } from '@cms-max/cms-browser-api-client'
import { GeneratorArgs } from './generateEventMap'
import { Activity, Component } from '@cms-max/medicare-api-sdk'

export const premiumHistoryGenerator = generator(({ i18n }: GeneratorArgs) => {
  const ns = 'premiumsHistory'

  return {
    premiums_paymenthistory_makeapayment_click: (params: {
        linkText?: string
        linkUrl?: string
      }): SiteActivityEvent => ({
      core: {
        property: 'MAX',
        activity: Activity.LinkClick,
        component: Component.Premiums,
        elementId: 'premiums_paymenthistory_makeapayment_click',
        coreClickData: {
          linkText: params.linkText,
          linkUrl: params.linkUrl
        }
      }
    }),
    premiums_paymenthistory_visitssaccount_click: (params: {
        linkText?: string
        linkUrl?: string
      }): SiteActivityEvent => ({
      core: {
        property: 'MAX',
        activity: Activity.LinkClick,
        component: Component.Premiums,
        elementId: 'premiums_paymenthistory_visitssaccount_click',
        coreClickData: {
          linkText: params.linkText,
          linkUrl: params.linkUrl
        }
      }
    }),
    premiums_paymenthistory_importantinfo_opendrawer: ({ date }: { date: string }) => {
      return {
        core: {
          activity: Activity.OpenDrawer,
          component: Component.Premiums,
          property: 'MAX',
          elementId: `premiums_paymenthistory_importantinfo${date}_opendrawer`
        }
      }
    },
    premiums_paymenthistory_importantinfo_closedrawer: ({ date }: { date: string }) => {
      return {
        core: {
          activity: Activity.CloseDrawer,
          component: Component.Premiums,
          property: 'MAX',
          elementId: `premiums_paymenthistory_importantinfo${date}_closedrawer`
        }
      }
    },
    premiums_paymenthistory_loadmore_click: {
      core: {
        activity: Activity.ButtonClick,
        component: Component.Premiums,
        property: 'MAX',
        elementId: 'premiums_paymenthistory_loadmore_click',
        coreClickData: {
          linkText: i18n.t('postedPayments.loadMore', { ns })
        }
      }
    },
    premiums_paymenthistory_loadall_click: {
      core: {
        activity: Activity.ButtonClick,
        component: Component.Premiums,
        property: 'MAX',
        elementId: 'premiums_paymenthistory_loadall_click',
        coreClickData: {
          linkText: i18n.t('postedPayments.loadAll', { ns })
        }
      }
    }
  }
})

export type PremiumHistoryKeys = keyof ReturnType<
  typeof premiumHistoryGenerator
>

export default premiumHistoryGenerator
